import { render, staticRenderFns } from "./table-paginator.vue?vue&type=template&id=4aa46eb0&scoped=true"
import script from "./table-paginator.vue?vue&type=script&lang=js"
export * from "./table-paginator.vue?vue&type=script&lang=js"
import style0 from "./table-paginator.vue?vue&type=style&index=0&id=4aa46eb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa46eb0",
  null
  
)

export default component.exports